import React from 'react';
import {Link} from "react-router-dom";

class Header extends React.Component{

componentDidMount(){
	window.onscroll =()=> {
		if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
			document.getElementById("nav").className = "navbar navbar-expand-lg navbar-light fixed-top py-2 py-md-3 px-3 px-md-5 is-sticky";
			//document.getElementById("signUp").className = "nav-item text-capitalize inactive";
		  } else {
			document.getElementById("nav").className = "navbar navbar-expand-lg navbar-light fixed-top py-2 py-md-3 px-3 px-md-5";
			//document.getElementById("signUp").className = "nav-item text-capitalize inactive hidden";
		  }
	};
}
    render(){
        return (
            <nav className="navbar navbar-expand-lg navbar-light fixed-top py-2 py-md-3 px-3 px-md-5" id="nav">
							<Link to='/' className="navbar-brand">
								<img src="assets/images/Logo/logo-new.svg" alt="" width="213" className="img-fluid"/>
							</Link>
			{/* <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarHeader" aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation"> */}
			{/*	 <span class="navbar-toggler-icon"></span> */}
			{/* </button> */}

			<div className="collapse navbar-collapse" id="navbarHeader">
				<ul className="navbar-nav ml-auto mt-2 mt-lg-0">
					{/* <li class="nav-item">
						<a class="nav-link font-weight-bold" href="buy-gift.html"><i class="fas fa-gift mr-1"></i> Buy a Gift card</a>
					</li>
					<li class="nav-item text-capitalize">
						<a class="nav-link" href="product.html">product</a>
					</li>
					<li class="nav-item text-capitalize">
						<a class="nav-link" href="pricing.html">Pricing</a>
					</li>
					<li class="nav-item text-capitalize">
						<a class="nav-link" href="education-center.html">education center</a>
					</li>
					<li class="nav-item text-capitalize">
						<a class="nav-link" href>About us</a>
					</li> */}
					{/* <li class="nav-item text-capitalize active">
						<a class="nav-link" href>Sign In</a>
					</li>
					<li class="nav-item text-capitalize inactive hidden" id="signUp">
						<a class="nav-link btn btn-warning rounded-pill text-white px-4 d-inline-block" href>Start your free trial</a>
					</li> */}
				</ul>
			</div>
		</nav>
        )
    }
}


export default Header;
